export function getBirths (state){
    return state.births
  }